import { Directive } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';

@Directive()
export abstract class PrPerFormBuilder extends PrFormAbstract {
  options: any = {};
  isAutomaticFlux: boolean;

  generate(entity: any, options?) {
    if (!entity.type) {
      entity.type = 'PER';
    }

    this.options = options;
    this.isAutomaticFlux = entity.subLabel?.includes('via EUODIA');

    console.log({ entity });

    let allocation: UntypedFormGroup[] = [];
    if (entity)
      _.forEach(entity.supports?.repartition?.series, (support, i) =>
        allocation.push(
          this.formBuilder.group(
            this.createModel(
              {
                id: support.id,
                isin: support.isin,
                index: i,
                name: support.label,
                allocationPercentage: support.percentage,
                favorite: '',
                type: '',
                supportDescription: '',
                totalInvestedAmount: entity?.lastValue,
                prSupportId: support.prSupportId,
                investedAmount: support.value,
              },
              i,
            ),
          ),
        ),
      );

    let group = this.formBuilder.group({
      id: [entity?.id || null],
      type: [entity ? entity.type : null, Validators.required],
      product: [entity ? entity.label : null, Validators.required],
      owners: [this.buildInitialOwners(entity), Validators.required],
      purchasePrice: [
        entity ? entity.purchasePrice : null,
        Validators.required,
      ],
      lastValue: [entity ? entity.lastValue : null],
      startDate: [entity ? entity.startDate : null, Validators.required],
      subscriptionSource: [
        entity?.subscriptionSource ? entity.subscriptionSource : 'BANK',
        Validators.required,
      ],
      accountId: [entity ? entity.accountId : null, Validators.required],
      userId: [entity ? entity.userId : null, Validators.required],
      subscriptionId: [entity ? entity.subscriptionId : null],
      monthlyPayment: [entity ? entity.monthlyPayment : null],
      investmentType: ['ASSETS', Validators.required],
      allocation: this.formBuilder.array(allocation, Validators.nullValidator),
    });

    this.form = group;

    return group;
  }

  public createModel(item, i?) {
    let model = {
      id: item?.id ? item.id : null,
      isin: item ? item.isin || item.supportIsin : null,
      index: item && item.index ? item.index : !_.isNil(i) ? i : null,
      omniprodId: item ? item.omniProductId || item.omniprodId : null,
      name: item ? item.name : null,
      allocationPercentage: item ? item.allocationPercentage : null,
      investedAmount: item ? item.investedAmount : null,
      totalInvestedAmount: item ? item.totalInvestedAmount : null,
      prSupportId: item ? item.prSupportId : null,
    };
    return model;
  }

  extract() {
    let assetSupportList;
    console.log({ allocation: this.form.value.allocation });

    if (!this.isAutomaticFlux)
      assetSupportList = _(this.form.value.allocation)
        .map(support => {
          return {
            ...support,
            label: support.name,
            isinCode: support.isin,
            percentage: support.allocationPercentage,
            initialAmount:
              this.form.value.lastValue * support.allocationPercentage,
            id: support.id ? support.id : undefined,
            prSupportId: support.prSupportId ? support.prSupportId : undefined,
            startDate: new Date().getTime(),
            currentVolumeDate: new Date().getTime(),
          };
        })
        .value();

    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      type: this.emptyIsNull(this.form.value.type),
      owners: this.form.value.owners,
      label: !this.isAutomaticFlux
        ? this.emptyIsNull(this.form.value.product.name)
        : undefined,
      purchasePrice: this.emptyIsNull(this.form.value.purchasePrice),
      lastValue: this.emptyIsNull(this.form.value.lastValue),
      startDate:
        new Date(this.form.value.startDate).toISOString().split('.')[0] + 'Z',
      subscriptionSource: this.emptyIsNull(this.form.value.subscriptionSource),
      accountId: this.emptyIsNull(this.form.value.accountId),
      userId: this.emptyIsNull(this.form.value.userId),
      subscriptionId: this.emptyIsNull(this.form.value.subscriptionId),
      monthlyPayment: this.emptyIsNull(this.form.value.monthlyPayment),
      productId: !this.isAutomaticFlux
        ? this.emptyIsNull(this.form.value.product.id)
        : undefined,
      status: 'STARTED',
      current: true,
      investmentType: this.emptyIsNull(this.form.value.investmentType),
      subLabel: !this.isAutomaticFlux
        ? this.emptyIsNull(this.form.value.product.managerName)
        : undefined,
      managerProviderId: !this.isAutomaticFlux
        ? this.emptyIsNull(this.form.value.product.managerId)
        : undefined,
      assetSupportList: assetSupportList,
    };
    return dto;
  }
}
